/* eslint-disable no-unused-expressions */
// Ce code a été copié tel quel afin de mettre à jour la librairie idle-js à 1.2.x au lieu de 0.3.x
// permettant ainsi de fonctionner avec "vite" avec npm run build
// Source: https://github.com/soixantecircuits/idle-vue/blob/master/src/index.js
// Bug: https://github.com/soixantecircuits/idle-vue/issues/52

// TODO: 2024-02-22 IdleJs est retiré cas il y a utilisation d'un "eval" non-supporté par CSP
// import IdleJs from 'idle-js';
import IdleTracker from 'idle-tracker';

export default {
  install(Vue, options) {
    const {
      eventEmitter,
      store,
      moduleName = 'idleVue',
      idleTime = 60 * 1000,
      events = ['mousemove', 'keydown', 'mousedown', 'touchstart'],
      keepTracking = true,
      startAtIdle = true,
    } = options || {};

    if (!eventEmitter && !store) {
      throw Error('Either `eventEmitter` or `store` must be passed in options');
    }

    store &&
      store.registerModule(moduleName, {
        state: { isIdle: startAtIdle },
        mutations: {
          [`${moduleName}/IDLE_CHANGED`](state, isIdle) {
            state.isIdle = isIdle;
          },
        },
      });

    const onIdleStr = `${moduleName}_onIdle`;
    const onActiveStr = `${moduleName}_onActive`;

    // TODO: 2024-02-22 IdleJs est retiré cas il y a utilisation d'un "eval" non-supporté par CSP
    // const idle = new IdleJs({
    //   idle: idleTime,
    //   events,
    //   keepTracking,
    //   startAtIdle,

    //   onIdle() {
    //     eventEmitter && eventEmitter.$emit(onIdleStr);
    //     store && store.commit(`${moduleName}/IDLE_CHANGED`, true);
    //   },
    //   onActive() {
    //     eventEmitter && eventEmitter.$emit(onActiveStr);
    //     store && store.commit(`${moduleName}/IDLE_CHANGED`, false);
    //   },
    // });
    // idle.start();

    // Source: https://github.com/roderickhsiao/idle-tracker
    const idleTracker = new IdleTracker({
      timeout: idleTime,
      onIdleCallback(objIdle) {
        if (objIdle.idle) {
          eventEmitter && eventEmitter.$emit(onIdleStr);
          store && store.commit(`${moduleName}/IDLE_CHANGED`, true);
        } else {
          eventEmitter && eventEmitter.$emit(onActiveStr);
          store && store.commit(`${moduleName}/IDLE_CHANGED`, false);
        }
      },
    });
    idleTracker.start();

    Vue.mixin({
      data() {
        return {
          [onIdleStr]: null,
          [onActiveStr]: null,
        };
      },
      computed: {
        isAppIdle() {
          return store && store.state[moduleName].isIdle;
        },
      },
      created() {
        if (eventEmitter && this.$options.onIdle) {
          this[onIdleStr] = this.$options.onIdle.bind(this);
          eventEmitter.$on(onIdleStr, this[onIdleStr]);
        }
        if (eventEmitter && this.$options.onActive) {
          this[onActiveStr] = this.$options.onActive.bind(this);
          eventEmitter.$on(onActiveStr, this[onActiveStr]);
        }
      },
      destroyed() {
        if (eventEmitter && this[onIdleStr]) {
          eventEmitter.$off(onIdleStr, this[onIdleStr]);
        }
        if (eventEmitter && this[onActiveStr]) {
          eventEmitter.$off(onActiveStr, this[onActiveStr]);
        }
      },
    });
  },
};
